import { defineMessages } from 'react-intl';

export const evidencePostUpgradeWelcomeMessages = defineMessages({
  ariaLabel: {
    defaultMessage: 'Welcome to Evidence',
    id: '6O3jB0uGvV',
    description: 'Accessible label for the post-checkout Evidence welcome card',
  },
  titleClinician: {
    defaultMessage: 'Welcome to Clinician',
    id: 'c2CP1/xlTD',
    description: 'Heading on post-upgrade welcome card for Clinician tier',
  },
  titlePractice: {
    defaultMessage: 'Welcome to Practice',
    id: 'b50HCNbET/',
    description: 'Heading on post-upgrade welcome card for Practice tier',
  },
  subtitle: {
    defaultMessage: "Watch Evidence in action, then explore what's new.",
    id: 'DDyolfHEAd',
    description: 'Supporting copy under the welcome heading',
  },
  seeWhatsNew: {
    defaultMessage: "See what's new",
    id: 'KNtMWuOWNS',
    description: 'Primary CTA on post-upgrade welcome card',
  },
  close: {
    defaultMessage: 'Close',
    id: 'w6sNqpd9uC',
    description: 'Accessible label for closing the welcome card',
  },
  videoTitle: {
    defaultMessage: 'Evidence walkthrough video',
    id: '1xWfWG5s6O',
    description: 'Title attribute / accessible name for the embedded Loom player',
  },
});
